type TextInputProps = {
  id?: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'password';
  autoComplete?: string;
  autoFocus?: boolean;
  inputMode?: 'numeric' | 'text';
  placeholder?: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
};

export function TextInput({
  id,
  name,
  label,
  type = 'text',
  autoComplete,
  autoFocus,
  inputMode,
  placeholder,
  required,
  minLength,
  maxLength,
  disabled,
  value,
  onChange,
}: TextInputProps) {
  return (
    <div>
      <label htmlFor={id ?? name} className="mb-2 block font-medium text-gray-700 text-sm">
        {label}
      </label>
      <div className="relative">
        <input
          id={id ?? name}
          name={name}
          type={type}
          maxLength={maxLength}
          minLength={minLength}
          autoComplete={autoComplete}
          // biome-ignore lint/a11y/noAutofocus: intentionally using autoFocus for this input field
          autoFocus={autoFocus}
          inputMode={inputMode}
          placeholder={placeholder}
          required={required}
          value={value}
          disabled={disabled}
          className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 text-sm placeholder-gray-400 shadow-xs transition focus:border-indigo-500 focus:outline-hidden focus:ring-indigo-500 disabled:bg-gray-100 disabled:text-gray-500"
          onChange={(event) => onChange(event.target.value)}
        />
        {maxLength && (
          <div className="absolute top-[9px] right-3 text-gray-500 text-sm">
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    </div>
  );
}
